import { motion } from 'framer-motion'

function ArticleRightItem({pill_text, article_heading, article_text, article_img, img_alt_text, background}) {
  return (
    <article className="article_right" style={{background: background}}>
        <motion.div
          initial={{ opacity: 0, x: -250}}
          whileInView={{opacity: 1, x: 0, transition: { duration: 0.5 }}}
          viewport={{once: true, amount: 0.2 }}
        >
            <img loading='lazy' src={article_img} alt={img_alt_text} />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 250}}
          whileInView={{opacity: 1, x: 0, transition: { duration: 0.5 }}}
          viewport={{once: true, amount: '1' }}
        >
            {pill_text && <p className="pill_text">{pill_text}</p>}
            <h1>{article_heading}</h1>
            {typeof(article_text) === "string" ? <p className="article_text">{article_text}</p>: article_text.map((article_paragraph, id) => <p key={id} className="article_text">{article_paragraph}</p>) }
        </motion.div>
    </article>
  )
}

export default ArticleRightItem